const ru = {
  description: `Крупнейшая бесплатная библиотека
когнитивных искажений (паттернов мышления)
с более чем 1000 примеров использования`,
};
export default ru;
